<div class="payline-account-card">
  <div ngbAccordion>
    <div class="d-flex align-items-center">
      <div class="d-flex gap-2 align-items-center">
        <app-radio-button-input
          formControlName="accountId"
          [value]="paylineAccount.id"
          [name]="'accountId'"
          [controlId]="'accountId' + generatedRandomId"
          (selectionChange)="selected.emit()" />
        <label class="payline-account-name" [for]="'accountId' + generatedRandomId" i18n>
          Payline {{ paylineAccount.accountNumber }}
        </label>
      </div>
      <button
        class="no-style-button accordion-header-button d-flex flex-grow-1 justify-content-end"
        (click)="toggleAccordionExpand()">
        <div>
          <img
            class="chevron"
            [src]="'assets/icons/grey/Chevron Up.svg'"
            [class.expanded]="accordionIsExpanded$ | async"
            [class.collapsed]="!(accordionIsExpanded$ | async)"
            alt="Toggle accordion"
            i18n-alt />
        </div>
      </button>
    </div>
    <div class="d-flex flex-column gap-3" ngbAccordionItem [collapsed]="!(accordionIsExpanded$ | async)">
      <div ngbAccordionCollapse>
        <div class="payline-info-grid">
          <app-review-entry label="Currency Type" i18n-label [value]="paylineAccount.currency.name" />
          <app-review-entry label="Account Number" i18n-label [value]="paylineAccount.accountNumber" />
          <app-review-entry label="Payline Bank" i18n-label [value]="paylineAccount.bankName" />
        </div>
        <div i18n class="date-added">Date Added: {{ paylineAccount.createdDate | date : 'MMM d, y' }}</div>
      </div>
    </div>
  </div>
</div>
